import React from 'react'
import { type FilterSection } from '../nureseries/SortFilterBar'

interface FilterBadgeProps {
  section: FilterSection
  value: string
  label: string
  onRemove: (section: FilterSection, value: string) => void
}

export const FilterBadge: React.FC<FilterBadgeProps> = ({ section, value, label, onRemove }) => {
  return (
    <div
      className="flex items-center gap-1 px-3 py-2 bg-white rounded-full text-sm shrink-0"
      style={{ border: '1px solid #189855', color: '#189855' }}
    >
      <span className="whitespace-nowrap">{label}</span>
      <button
        onClick={() => onRemove(section, value)}
        className="ml-1 hover:opacity-70 transition-opacity shrink-0"
        style={{ color: '#189855' }}
        aria-label={`Remove ${label} filter`}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.2 12L0 10.8L4.8 6L0 1.2L1.2 0L6 4.8L10.8 0L12 1.2L7.2 6L12 10.8L10.8 12L6 7.2L1.2 12Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  )
}
